var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","small":"","loading":_vm.loading},on:{"click":_vm.paste}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-content-paste ")]),_vm._v(" paste ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }